export default __webpack_public_path__ + "static/media/listViewMobile.b5e66cbc.svg";